export { default } from './image-loader';
